module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_7-61f4058ceb4af02a4e43815788822264.png";